import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: "en", // Default language
    debug: false,
    initAsync: false,
    fallbackLng: "en",
    backend: {
      loadPath: "/asset/locales/{{lng}}/{{lng}}.json", // Path to translation files
    },
    interpolation: {
      escapeValue: false, // React already handles escaping
    },
    react: {
      wait: true,
      // useSuspense: false,
    },
  });

export default i18n;
